import { useMutation, useQueryClient } from 'react-query';
import { SchemaBlockedNumberService } from '@frontend/api-call-block';
import { phoneAuditsQueryKeys } from '@frontend/api-phone-audits';
import { useInvalidateQueries } from '@frontend/location-helpers';
import { queryKeys } from '../../query-keys';
import { BlockedNumberCreatePayload } from './types';

export const useCallBlockMutations = (phoneTenantId: string) => {
  const invalidateQueries = useInvalidateQueries();
  const queryClient = useQueryClient();

  const create = useMutation({
    mutationFn: (payload: BlockedNumberCreatePayload) => {
      return SchemaBlockedNumberService.CreateBlockedNumber(payload);
    },
    onSettled: () => {
      invalidateQueries([phoneTenantId, ...queryKeys.settings.listCallBlock()]);
      queryClient.invalidateQueries(phoneAuditsQueryKeys.searchAuditEventsByTenant(phoneTenantId));
    },
  });

  const remove = useMutation({
    mutationFn: (payload: { id: string }) => {
      return SchemaBlockedNumberService.DeleteBlockedNumber(payload);
    },
    onSettled: (_data, _err) => {
      invalidateQueries([phoneTenantId, ...queryKeys.settings.listCallBlock()]);
      queryClient.invalidateQueries(phoneAuditsQueryKeys.searchAuditEventsByTenant(phoneTenantId));
    },
  });

  return {
    create,
    remove,
  };
};
